// src/components/notifications/NotificationsBulkActions.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Paper,
  Typography,
  Button,
  Stack,
} from '@mui/material';
import {
  MarkEmailRead as MarkReadIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';

export default function NotificationsBulkActions({
  selectedCount,
  onMarkAsRead,
  onDelete,
  onClearSelection,
}) {
  const { t } = useTranslation();

  if (selectedCount === 0) return null;

  return (
    <Paper elevation={2} sx={{ p: 2, mb: 3, backgroundColor: 'primary.main', color: 'primary.contrastText' }}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="body1">
          {t('notifications:bulk_actions.selected_count', { count: selectedCount })}
        </Typography>
        <Stack direction="row" spacing={1}>
          <Button
            size="small"
            variant="outlined"
            sx={{ color: 'inherit', borderColor: 'inherit' }}
            startIcon={<MarkReadIcon />}
            onClick={onMarkAsRead}
          >
            {t('notifications:bulk_actions.mark_as_read')}
          </Button>
          <Button
            size="small"
            variant="outlined"
            sx={{ color: 'inherit', borderColor: 'inherit' }}
            startIcon={<DeleteIcon />}
            onClick={onDelete}
          >
            {t('notifications:bulk_actions.delete')}
          </Button>
          <Button
            size="small"
            variant="outlined"
            sx={{ color: 'inherit', borderColor: 'inherit' }}
            onClick={onClearSelection}
          >
            {t('notifications:bulk_actions.clear_selection')}
          </Button>
        </Stack>
      </Box>
    </Paper>
  );
}